import { render, staticRenderFns } from "./RelatorioDeDivergencia.vue?vue&type=template&id=73077e32"
import script from "./RelatorioDeDivergencia.vue?vue&type=script&lang=js"
export * from "./RelatorioDeDivergencia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports